/**
 * Événements temps réel poussés par l'API (Server-Sent Events).
 * Ils sont volontairement « légers » : ils signalent ce qui a changé,
 * le client recharge ensuite les données concernées.
 */
export type ServerEvent =
  { type: 'notes'; ids: string[] } | { type: 'labels' } | { type: 'profile' };

/** En-tête envoyé par le client pour ne pas recevoir l'écho de ses propres modifications. */
export const CLIENT_ID_HEADER = 'x-client-id';
